<div class="delete-paylink">
  <h2
    *ngIf="selectedPaylink.length <= 1"
    class="headline">{{'PAYMENT_LINK_PAGE.MODAL_DELETE.DELETE_PAYLINK' | translate}}</h2>
  <h2
    *ngIf="selectedPaylink.length > 1"
    class="headline">{{'PAYMENT_LINK_PAGE.MODAL_DELETE.DELETE_PAYLINK_MULTI' | translate}}
  </h2>
  <p
    *ngIf="selectedPaylink.length <= 1"
    class="description">{{'PAYMENT_LINK_PAGE.MODAL_DELETE.DELETE_DESCRIPTION_1' | translate}}</p>
  <p
    *ngIf="selectedPaylink.length > 1"
    class="description">{{'PAYMENT_LINK_PAGE.MODAL_DELETE.DELETE_DESCRIPTION_2' | translate}}</p>
  <h3
    *ngIf="selectedPaylink.length <= 1"
    class="subtitle">ID: {{selectedPaylink[0]}}</h3>

  <h3
    *ngIf="selectedPaylink.length > 1"
    class="subtitle">{{'PAYMENT_LINK_PAGE.MODAL_DELETE.DELETE_PAYLINK_COUNT' | translate}}
    : {{selectedPaylink.length}}</h3>
  <div class="btn-block">
    <button
      (click)="deletePaylink()"
      class="btn btn-danger">{{'PAYMENT_LINK_PAGE.MODAL_DELETE.DELETE_BUTTON' | translate}}</button>
    <button
      (click)="closeModal()"
      class="btn btn-light">{{'PAYMENT_LINK_PAGE.MODAL_DELETE.DELETE_CANCEL' | translate}}</button>
  </div>
</div>

